import React, { ReactElement } from "react";
import { InnerWrapper, OuterWrapper } from "./styled";

export interface Props {
  coverageDetailsCard?: boolean;
  insuranceDetailsCard?: boolean;
  dynamicInsuranceDetailsCard?: boolean;
  adviceDetailsCard?: boolean;
  additionalCoverage?: boolean;
  space?: string;
  borderRadius?: string;
  padding?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const ColorWrapper = ({
  coverageDetailsCard = false,
  insuranceDetailsCard = false,
  dynamicInsuranceDetailsCard = false,
  adviceDetailsCard = false,
  additionalCoverage = false,
  space = "8px",
  borderRadius = "0",
  padding = "16px",
  children,
  selected,
  disabled,
  onClick,
}: React.PropsWithChildren<Props>): ReactElement => {
  return (
    <OuterWrapper space={space} borderRadius={borderRadius}>
      <InnerWrapper
        insuranceDetailsCard={insuranceDetailsCard}
        dynamicInsuranceDetailsCard={dynamicInsuranceDetailsCard}
        adviceDetailsCard={adviceDetailsCard}
        coverageDetailsCard={coverageDetailsCard}
        additionalCoverage={additionalCoverage}
        padding={padding}
        selected={selected}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default ColorWrapper;
